/**
 * Frontend paths whose route differs from the identity-service screen `route`, mapped to the
 * screen `code` that governs them. Lets the subsidiary screen-enablement check
 * (`useSubsidiaryScreens`) gate these pages even though path matching alone would miss them —
 * e.g. the Subsidiary Settings "User Management" page lives at `/subsidiary/users` while its
 * screen (`admin_subsidiary_members`) is registered at `/subsidiary/members`.
 */
export const SCREEN_CODE_BY_PATH: Record<string, string> = {
  '/subsidiary/roles': 'admin_roles',
  '/subsidiary/users': 'admin_subsidiary_members',
  '/subsidiary/subsidiaries': 'org_subsidiaries',
  '/subsidiary/screen-access': 'admin_screen_access',
  '/subsidiary/access-policy': 'admin_abac_policies',
  '/subsidiary/access-control': 'admin_abac_users',
  '/subsidiary/sso': 'admin_sso',
  '/subsidiary/data-sharing': 'integrations_sharing',
};
